export default {
  Subs: {
    For: "Assinatura para",
    PTM: "Plataforma para médicos «" + process.env.VUE_APP_INSTALL_NAME + "»",
    BySub: "Por assinatura",
    Free: "Gratuito",
    CostDesc: "em <period> por usuário",
    month: "mês",
    day: "dia",
    year: "ano",
    Connect: "Conectar",
    Connectv2: "Ativar assinatura",
    CorpPlan: {
      desc: "Individual",
      feature_1: "Programas personalizados",
      feature_2:
        "Processamento de uma quantidade definida de exames por mês usando qualquer IA",
      cost: "Sob consulta",
      request: "Enviar solicitação",
      requested: "Sua solicitação foi enviada com sucesso!",
      requested2:
        "Entraremos em contato com você em breve para discutir todos os detalhes e oferecer a melhor solução. Se tiver dúvidas, <a target='_blank' class='demo__underline' href='https://t.me/thirdopinion_support_bot'>fale conosco!</a>",
    },
    yourSub: "Sua assinatura",
    PlansDesc: "Descrição detalhada dos planos",
    Offer: "Oferta",
    EnterPromo: "Insira o código promocional",
    Errors: {
      NotPurchase:
        "Não foi possível ativar a assinatura, tente novamente mais tarde",
    },
    DiffSubs: "Diferenças entre os planos",
    Plan: "Plano",
    Unavailable: "É necessário cancelar a anterior primeiro",
    extSub: "Selecionar avançado",
    lets: {
      modalTitle: {
        base: "Digite seu",
        and: " e ",
        phone: " número de telefone",
        email: " e email",
      },
      text: "Para completar a assinatura, é necessário inserir seu<PHONE><EMAIL>. Isso permitirá o envio de notificações sobre o status da assinatura, confirmações e outras mensagens importantes",
      formInvalid: "O formulário está preenchido incorretamente",
    },
    cancelSub: "Cancelar",
    unsub: {
      title: "Você não terá mais acesso a:",
      modalTitle: "Tem certeza de que deseja cancelar sua assinatura?",
      modalTitle2: "Escolha o motivo do cancelamento",
      cancel: "A assinatura <NAME> foi retomada. Próximo pagamento em <DATE>",
      yes: "Cancelar assinatura",
      no: "Manter assinatura",
      thx: {
        title: "Obrigado por continuar conosco!",
        continue: "Continuar usando o serviço",
      },
      reasons: {
        0: "Preço alto",
        1: "Não utilizo o serviço",
        2: "Interface pouco conveniente",
        3: "Outro",
      },
      complete: {
        title: "Você cancelou a assinatura",
        text1: "Sua assinatura permanecerá ativa até ",
        text2:
          ", e você poderá continuar usando o serviço até essa data. Esperamos vê-lo novamente!",
        recover: "Retomar assinatura",
      },
    },
    backToSite: "Voltar ao site",
    afterPay: {
      title: "Sua assinatura foi ativada com sucesso!",
      text: "Agora você tem acesso a todos os recursos avançados do serviço!",
      buttonText: "Começar",
    },
  },
};
